import { render, staticRenderFns } from "./AppointmentView.vue?vue&type=template&id=72c1c610&"
import script from "./AppointmentView.vue?vue&type=script&lang=js&"
export * from "./AppointmentView.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports